<template>
  <section v-show="isApproved || WP.user.id === authorId" :id="'comment-' + id"
           class="relative my-5 scroll-mt-28" style="overflow-anchor: none;">
	  <CouponTutorialModal @close="isCouponTutOpen = false;" v-if="isCouponTutOpen && window.size.mobile" />
    <div>
      <div class="relative shadow shadow-zt-shadow bg-zt-normal border -m-[1px] rounded-zt"
           :class="showNewBetShadow ? 'border-zt-more' : 'border-zt-normal', {'z-backdrop': isBetOptionsModalOpen || isReportModalOpen }">
        <Transition name="fade">
          <bet-options-modal
              v-if="isBetOptionsModalOpen"
              :betId="id"
              :authorId="authorId"
              :authorName="authorName"
              :isBlocked="isUserBlocked"
              :isFollowed="isFollowed"
              :isWarned="isWarned"
              :warnCount="warnCount"
              :isReported="isReported"
              :isSettled="settled"
              :isBetFollowed="isBetFollowed"
              :showCouponAdd="showCouponAdd"
              :betPostId="postId"
              @close="hideBetOptionsModal"
              @block="blockUser"
              @unblock="unblockUser"
              @follow="follow"
              @unfollow="unfollow"
              @followPost="followPost"
              @unfollowPost="unfollowPost"
              @edit="edit"
              @warn="warnUser"
              @removeReport="removeReport"
              @addReport="addReport"
              @reportBet="showReportModal"
              @removeWarn="removeWarnUser"
              @copyBet="copyUserBet"
              @deleteBet="deleteBet"
              @settleBet="settleBet"
              @addToCoupon="addToCoupon"/>
        </Transition>
        <Transition name="fade">
          <report-modal
              v-if="isReportModalOpen"
              :id="id"
              :type="'bet'"
              :link-to-reported-item="`${window.location.origin}/?p=${postId}#comment-${id}/`"
              @close="hideReportModal"/>
        </Transition>
        <div v-if="!isApproved" class="pt-3">
          <p class="font-medium ml-4 text-zt-red text-xs xl:text-sm">W trakcie weryfikacji przez administratorów. Proszę czekać</p>
          <hr class="border-b-2 border-zt-light/30 mx-auto w-full !border-t-0 mt-2.5" />
        </div>
        <div :class="{ 'opacity-60 pointer-events-none': !isApproved }">
          <div v-if="awardType" class="bg-[#2D3C4F] border-b-[2px] rounded-t-zt border-zt-light !min-h-8 flex justify-center items-center">
            <span class="text-sm text-zt-red font-medium uppercase">{{ getAwardText(data.award_type) }}</span>
          </div>
          <div v-if="awardType && supportLink" class="py-3 border-b px-3 border-zt-light flex justify-between items-center xl:px-0 xl:justify-center xl:gap-x-2.5">
            <p class="text-sm font-normal">Wesprzyj tego Typera i podziękuj mu za typ/analizę</p>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                @click="redirect"
                class="bg-[#4c586c] w-8 h-8 p-1 rounded-zt border border-zt-more zt-hover cursor-pointer"
                width="31" height="27" viewBox="0 0 31 27" fill="none">
              <path d="M19.2114 0.520782C18.4457 0.613195 17.8825 0.771618 17.3148 1.05766C15.3697 2.0434 14.2652 4.1909 14.5864 6.3472C14.8416 8.01503 15.889 9.44083 17.4028 10.1757C18.569 10.7434 19.9596 10.8358 21.2137 10.431C21.6054 10.3078 22.2215 9.99971 22.5691 9.75327C22.9608 9.47604 23.5593 8.86435 23.8233 8.46829C24.1225 8.02383 24.4086 7.39014 24.5494 6.88847C24.655 6.49242 24.6638 6.3912 24.6638 5.59909C24.6638 4.80258 24.655 4.71017 24.545 4.30091C23.9905 2.25463 22.2391 0.754015 20.1532 0.538385C19.7219 0.494379 19.4843 0.489979 19.2114 0.520782ZM20.0696 2.22382V2.63308L20.4568 2.68589C20.8353 2.73429 21.3898 2.89712 21.3898 2.94992C21.3898 2.98073 21.1609 3.89606 21.1477 3.91366C21.1477 3.91806 20.9937 3.87405 20.8133 3.80804C20.558 3.71563 20.382 3.68923 19.9772 3.67162C19.5239 3.65402 19.4491 3.66282 19.2863 3.74643C19.185 3.79924 19.0838 3.87845 19.0574 3.92246C18.9826 4.06328 19.0046 4.34492 19.1014 4.46373C19.207 4.60015 19.6471 4.82899 20.206 5.04462C20.8969 5.30865 21.2929 5.60349 21.513 6.01715C21.6186 6.21518 21.6318 6.28119 21.6318 6.69925C21.6318 7.12171 21.623 7.18332 21.4998 7.41655C21.2753 7.86101 20.7825 8.23506 20.2324 8.37588L20.0256 8.42429V8.90396V9.38362H19.5855H19.1498L19.1366 8.93036L19.1234 8.4815L18.8374 8.45069C18.4985 8.41989 18.0585 8.30987 17.7768 8.18666L17.57 8.10304L17.7064 7.57937L17.8429 7.0601L18.0013 7.13931C18.0849 7.18332 18.3049 7.26253 18.4853 7.31973C18.9298 7.46055 19.6955 7.46936 19.9552 7.34174C20.1884 7.22292 20.2984 7.03809 20.2764 6.79606C20.2412 6.47482 19.9728 6.26359 19.2643 6.01275C18.1421 5.60789 17.6316 5.08862 17.636 4.34492C17.6404 3.60121 18.1069 3.03794 18.9254 2.7783L19.1674 2.70349L19.1806 2.25903L19.1938 1.81456H19.6295H20.0696V2.22382Z" fill="white"/>
              <path d="M11.2626 11.3053C11.201 11.3141 11.0029 11.3449 10.8225 11.3713C9.23388 11.6045 7.2184 12.9159 5.55937 14.8082C5.01809 15.4243 4.94328 15.5299 5.00049 15.6047C5.02689 15.6311 6.14025 17.0921 7.47804 18.848C8.81582 20.6038 9.93798 22.0648 9.96878 22.1C10.0216 22.1572 10.0524 22.144 10.2152 22.0252C10.8225 21.5719 11.9359 20.9603 12.7368 20.639C13.7753 20.2253 14.1098 20.1813 16.6313 20.1021C18.6116 20.0405 19.1397 20.0053 19.9098 19.8777C20.6975 19.7457 21.4896 19.4508 22.6426 18.8524C25.2301 17.5102 29.3491 14.575 30.1236 13.5188C30.4581 13.0611 30.5505 12.5287 30.3612 12.1414C30.2512 11.9126 29.8376 11.5165 29.6131 11.4197C29.0279 11.1733 27.2148 11.9038 24.7813 13.3692L24.0464 13.8093L24.02 14.5134C23.9891 15.2747 23.9495 15.4507 23.7163 15.7851C23.3335 16.3484 22.4973 16.7093 21.1463 16.8985C20.4907 16.9909 18.0703 17.0041 17.0494 16.9205C15.1615 16.7621 14.0085 16.6168 14.585 16.608C14.7082 16.6036 16.2617 16.5244 18.0395 16.4276C21.4984 16.2428 21.6348 16.2296 22.2025 15.97C22.4973 15.8335 22.8582 15.4991 22.9902 15.2395C23.1222 14.9754 23.2058 14.5266 23.1662 14.2537C23.109 13.8137 22.867 13.5364 22.3697 13.3516C21.9561 13.1932 21.5908 13.1624 20.1606 13.1668C19.3993 13.1712 18.5588 13.1492 18.2903 13.1228C17.0802 13.0083 16.0064 12.7047 14.5498 12.0798C13.6037 11.6706 13.0932 11.4857 12.6268 11.3889C12.2967 11.3185 11.4694 11.2701 11.2626 11.3053Z" fill="white"/>
              <path d="M3.47649 15.9721C3.29606 16.0469 0.118817 18.5244 0.0616086 18.63C0.0264037 18.7005 0 18.8413 0 18.9513C0 19.1405 0.0616086 19.2241 2.75038 22.749C4.2642 24.7293 5.55358 26.3839 5.62399 26.4235C5.77801 26.5247 6.10805 26.5247 6.24887 26.4279C6.63613 26.1639 9.47892 23.9636 9.54933 23.8712C9.65055 23.748 9.66815 23.4311 9.58894 23.2771C9.50973 23.1275 4.20259 16.1965 4.07497 16.0777C3.96055 15.9721 3.62171 15.9105 3.47649 15.9721ZM7.37983 22.6126C7.82429 22.9646 7.82429 23.5895 7.37983 23.9108C7.08499 24.122 6.75494 24.1352 6.4645 23.9372C6.02444 23.6423 5.96283 23.0879 6.32808 22.7006C6.50411 22.5158 6.67573 22.4498 6.96177 22.4674C7.1642 22.4806 7.24781 22.507 7.37983 22.6126Z" fill="white"/>
            </svg>
          </div>
          <div v-if="commentType === 'bet'"
               class="flex relative items-center rounded-t-md border-b border-zt-light/35
                 pr-4 pl-3 py-3 xl:pl-4 xl:pr-[18px] xl:pt-2.5 xl:pb-3"
               :class="[commentType === 'advert' ? ['h-fit', 'px-6'] : '']">
            <div class="flex w-full items-center truncate">
              <a class="no-default-style flex group items-center w-fit truncate1"
                 :href="'/typer/' + authorId" rel="nofollow" :aria-label="`Sprawdź profil ${authorName}`"
                 @click="changeUrl" >
                <div class="shrink-0 !mb-0">
                  <div class="relative">
                    <img class="rounded-full object-cover mr-2 group-hover:brightness-90 group-active:brightness-75 w-[45px] h-[45px] xl:mr-2.5 xl:w-[50px] xl:h-[50px]"
                         :class="isModal ? 'post-thumbnail' : ''"
                         :src="authorAvatar" alt="Avatar" width="50" height="50" @error="handleUserAvatarError($event)"/>
                    <div v-if="isBlocked"
                         class="opacity-40 absolute top-0 left-0 rounded-full bg-black w-[50px] h-[50px]
                          flex items-center justify-center">
                      <svg class="w-[30px] h-[30px]" viewBox="0 0 214 319" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M197.131 122.59H16.2847C6.8567 122.59 0 130.305 0 138.878V302.617C0 312.048 7.71379 318.906 16.2847 318.906H197.131C206.559 318.906 213.415 311.19 213.415 302.617V138.878C213.415 130.305 205.701 122.59 197.131 122.59ZM128.563 270.898H85.7089C79.7093 270.898 75.4239 264.897 77.9951 258.896L91.7085 229.749C93.4227 226.32 92.5656 222.034 89.1373 219.462C83.1377 214.318 79.7093 207.46 79.7093 198.887C79.7093 178.313 101.994 162.882 124.278 176.598C126.849 178.313 128.563 180.027 129.42 182.599C137.991 197.173 134.563 211.746 125.135 220.319C122.564 222.891 120.85 227.177 122.564 230.606L136.277 259.754C137.991 264.04 134.563 270.898 128.563 270.898Z" fill="white" />
                        <path d="M107.138 0C64.2836 0 30 35.1483 30 77.1547V102.016H62.5694V77.1547C62.5694 52.2938 82.2825 32.5764 107.138 32.5764C131.994 32.5764 151.707 52.2938 151.707 77.1547V102.016H184.276V77.1547C185.133 34.291 149.993 0 107.138 0Z" fill="white" />
                      </svg>
                    </div>
                    <div v-if="isFollowed"
                         class="absolute right-1 bottom-0 bg-zt-main rounded-full w-5 h-5 flex justify-center items-center xl:right-0"
                         :class="{ 'animate-[show-up_1s_ease-in-out]': followChanged }"
                         data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-delay="500" title="Obserwujesz">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" fill="#3A4B64"/>
                        <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="white"/>
                        <path d="M10.1293 5.00512C9.23895 5.1766 8.5718 5.78033 8.3181 6.64715C8.26642 6.81629 8.26172 6.87971 8.26172 7.29316C8.26172 7.77943 8.28051 7.92507 8.39092 8.37375C8.64228 9.37448 9.15438 10.1544 9.76046 10.4527C10.0447 10.5913 10.2021 10.6289 10.5051 10.6289C10.9843 10.6289 11.3391 10.4762 11.7055 10.1121C12.2294 9.59529 12.5794 8.81069 12.725 7.82876C12.7791 7.46465 12.7626 6.88676 12.6898 6.63776C12.469 5.86959 11.8841 5.28466 11.1135 5.05915C10.9749 5.01921 10.8645 5.00747 10.5639 5.00277C10.3571 4.99807 10.1622 5.00042 10.1293 5.00512Z" fill="white"/>
                        <path d="M6.88779 6.89214C6.7304 6.94382 6.6012 7.05657 5.77196 7.88346C5.28099 8.37443 4.87225 8.77378 4.8652 8.77378C4.85815 8.77378 4.69841 8.62109 4.51048 8.43551C4.10174 8.03146 4.02187 7.98917 3.70474 8.00327C3.48392 8.01267 3.34532 8.06904 3.20202 8.21234C3.03993 8.37443 3 8.48719 3 8.77378C3 9.00399 3.0047 9.02748 3.06812 9.12615C3.10571 9.18487 3.42284 9.51845 3.77286 9.86847C4.49169 10.5873 4.52693 10.6108 4.82526 10.6249C5.18468 10.6437 5.09306 10.7165 6.49549 9.31643C7.18613 8.62813 7.76401 8.03381 7.79925 7.97508C7.85563 7.87877 7.86267 7.84823 7.86267 7.63446C7.86267 7.36196 7.82039 7.2445 7.66065 7.08476C7.51265 6.93677 7.3811 6.88274 7.14619 6.87804C7.03578 6.87569 6.92068 6.88039 6.88779 6.89214Z" fill="white"/>
                        <path d="M8.58047 10.6807C7.52337 11.0166 6.95723 11.2327 6.71527 11.3854C6.34881 11.6203 6.03403 12.3956 6.00349 13.1308C5.99174 13.3798 5.99644 13.4292 6.04342 13.5466C6.0998 13.6993 6.25014 13.8661 6.40519 13.9483L6.5015 14H10.495H14.4885L14.5942 13.9483C14.6529 13.9178 14.7375 13.8591 14.7821 13.8144C14.8268 13.7698 14.8714 13.7392 14.8785 13.7439C14.8878 13.7486 14.9137 13.7299 14.9372 13.6993C14.9818 13.65 14.9818 13.65 14.9372 13.6829C14.9113 13.7017 14.8972 13.7064 14.9043 13.6946C14.909 13.6805 14.9301 13.6359 14.9466 13.5936C14.9654 13.5537 14.9865 13.5184 14.9936 13.5184C15.0264 13.5184 15.017 13.004 14.9842 12.816C14.9654 12.708 14.9513 12.6117 14.9513 12.6046C14.9536 12.5976 14.9489 12.5741 14.9395 12.5553C14.8761 12.3838 14.8738 12.3603 14.9278 12.2992L14.9818 12.2382L14.9301 12.2828C14.8785 12.3251 14.8761 12.3251 14.862 12.2828C14.6976 11.8177 14.5143 11.524 14.2959 11.3854C14.0563 11.2304 13.3374 10.9555 12.5881 10.7324L12.238 10.629L12.1582 10.6924C11.841 10.9508 11.7353 11.0213 11.5286 11.1223C11.1293 11.3197 10.7933 11.3831 10.3188 11.3525C9.90772 11.3291 9.52951 11.1928 9.156 10.9321C9.06439 10.8686 8.94693 10.7747 8.89525 10.723C8.84592 10.6713 8.78719 10.6314 8.7684 10.6314C8.7496 10.6337 8.66504 10.6549 8.58047 10.6807Z" fill="white"/>
                      </svg>
                    </div>
                    <div v-if="isUserWarned"
                         class="absolute bg-orange-400 w-4 h-4 left-0 top-0 rounded-full no-default-style flex items-center justify-center">
                      <div class="text-sm">{{ warnCount }}</div>
                    </div>
                  </div>
                </div>
                <div class="block w-fit px-0.5 truncate">
			            <span class="font-medium searched-in group-hover:brightness-90 group-active:brightness-75
                          group-hover:underline group-active:underline text-sm xl:text-base"
                        :class="window.size.mobile ? 'whitespace-pre' : 'whitespace-normal'"
			                  v-html="authorName"></span>
                </div>
              </a>
            </div>
            <div class="rounded-lg relative shrink-0 flex flex-col justify-center items-stretch
                   py-1.5 px-0.5 gap-1 cursor-pointer overflow-hidden border border-zt-light mr-5 basis-[80px] h-[42px]
                   xl:h-[49px] xl:basis-[99px] xl:mr-10"
                 data-bs-trigger="click" data-bs-toggle="tooltip" data-bs-placement="bottom"
                 title="Skuteczność Typera w ost. 30 dniach. W nawiasie liczba typów."
                 @click="hideTooltip"
                 style="box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);">
              <p class="text-center font-['Lato'] font-semibold text-sm select-none">
                {{ Math.round((authorStats.ratio * 100).toFixed(1)) + '%' }} <span class="font-normal">({{ authorStats.bet_count }})</span>
              </p>
              <div class="flex justify-between items-center gap-1 px-2.5">
                <div v-for="i in 5" :key="i"
                     class="h-1 rounded-[1px] w-[6px] xl:w-2.5"
                     :style="{ backgroundColor: i <= getBatteryType() ? getBatteryColor() : getBatteryColor() + '26' }"></div>
              </div>
            </div>
            <div class="basis-8 h-8 shrink-0 rounded-full ml-auto cursor-pointer highlight-none fill-[#D9D9D9]
                   transition-colors self-center flex justify-center items-center m-0 zt-hover hover:bg-zt-light xl:self-center"
                 role="link" aria-label="Pokaż opcje"
                 @click="showBetOptionsModal('comment-' + id)">
              <svg width="23" height="5" viewBox="0 0 23 5" xmlns="http://www.w3.org/2000/svg">
                <ellipse cx="20.5" cy="2.49031" rx="2.5" ry="2.49031" />
                <ellipse cx="11.5" cy="2.49031" rx="2.5" ry="2.49031" />
                <ellipse cx="2.5" cy="2.49031" rx="2.5" ry="2.49031" />
              </svg>
            </div>
          </div>

          <div v-if="bookmaker && !isBlockedBetShown" class="add-bet flex flex-col pt-2 px-2.5 xl:px-4">
            <div class="grid grid-cols-3 gap-2 pb-2.5 pt-1 xl:pt-2">
              <div class="flex flex-col items-center relative gap-1.5 xl:gap-3">
                <div class="bg-zt-main basis-10 w-10 h-10 rounded-xl flex justify-center items-center">
                  <img v-if="discipline.toLowerCase() !== 'inna' || discipline !== 'Pozostałe'"
                       class="w-[22px] h-[22px] opacity-50" :class="isModal ? '!m-0' : ''"
                       :src="'/wp-content/themes/zawodtyper/assets/images/dyscypliny/' + disciplineLogoName.replace(' ', '').toLowerCase() + '.svg'"
                       :alt="discipline" />
                  <img v-else 
                       class="w-[22px] h-[22px] opacity-50"
                       :class="isModal ? '!m-0' : ''"
                       :src="'/wp-content/themes/zawodtyper/assets/images/dyscypliny/inna.svg'" :alt="discipline"
                       width="20" height="20" />
                </div>
                <div class="text-center">
                  <p class="text-[#ABC1E2] text-xs font-semibold">DYSCYPLINA</p>
                  <div v-if="!toEdit">
                    <div @click="changeFiltering(discipline)"
                         :id="'discipline' + data.comment_id" :contenteditable="toEdit"
                         class="searched-in underline zt-hover cursor-pointer text-sm whitespace-nowrap overflow-hidden overflow-ellipsis font-medium mt-[3px] xl:mt-0"
                         v-html="discipline"></div>
                  </div>
                  <select v-else :id="'discipline' + data.comment_id"
                          class="text-white w-full rounded-md bg-zt-normal border-white/50 border h-8 text-sm mt-1
                            focus:outline-none"
                          v-model="discipline">
                    <option v-for="(discipline, index) in disciplines" :selected="index === 0">
                      {{ discipline.title }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="flex flex-col items-center relative gap-1.5 xl:gap-3">
                <div class="bg-zt-main basis-10 w-10 h-10 rounded-xl flex justify-center items-center">
                  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.9977 14.5269L14.5252 12.9994L9.1627 7.63689L7.63521 9.16439L12.9977 14.5269ZM20.6569 5.34022C19.6536 4.33081 18.4601 3.53049 17.1454 2.98563C15.8306 2.44077 14.4209 2.1622 12.9977 2.16606H11.9144V6.49939H14.081V4.39772C16.0239 4.64329 17.8264 5.53963 19.1946 6.94068C20.5629 8.34172 21.4164 10.1649 21.6159 12.113C21.8154 14.0612 21.3492 16.0195 20.2933 17.6688C19.2375 19.3181 17.6541 20.5612 15.8013 21.1955C13.9485 21.8298 11.9356 21.8179 10.0904 21.1617C8.24528 20.5055 6.67676 19.2438 5.64047 17.5821C4.60418 15.9204 4.16122 13.9567 4.38378 12.0111C4.60633 10.0654 5.48128 8.25248 6.86604 6.86772L7.63521 6.10939L6.10771 4.57106L5.33854 5.34022C4.30384 6.33956 3.47854 7.53496 2.91077 8.85667C2.34301 10.1784 2.04416 11.5999 2.03166 13.0384C2.01916 14.4768 2.29326 15.9033 2.83797 17.2347C3.38268 18.5661 4.18709 19.7757 5.20426 20.7928C6.22143 21.81 7.43099 22.6144 8.76237 23.1591C10.0937 23.7038 11.5203 23.9779 12.9587 23.9654C14.3972 23.9529 15.8187 23.6541 17.1404 23.0863C18.4621 22.5186 19.6575 21.6933 20.6569 20.6586C22.6878 18.627 23.8287 15.872 23.8287 12.9994C23.8287 10.1268 22.6878 7.37177 20.6569 5.34022Z" fill="#93A3BA"/>
                  </svg>
                </div>
                <div class="text-center">
                  <p class="text-[#ABC1E2] text-xs font-semibold">GODZINA</p>
                  <div :id="'hour' + data.comment_id" :contenteditable="toEdit"
                       class="text-sm whitespace-nowrap overflow-hidden overflow-ellipsis font-medium mt-[3px] xl:mt-0">
                    {{ hour }}
                  </div>
                </div>
              </div>
              <div class="flex flex-col items-center gap-1.5 xl:gap-3">
                <div class="bg-zt-main basis-10 w-10 h-10 rounded-xl flex justify-center items-center">
                  <img class="w-6 h-6 cursor-pointer zt-hover"
                       :src="`/wp-content/themes/zawodtyper/assets/images/bukmacherzy/logo_${bookmakerLogoName.toLowerCase().replaceAll(' ', '')}_kod_promocyjny.svg`"
                       :alt="`Logo ${bookmakerLogoName} kod promocyjny`"
                       width="24" height="24"
                    @click="redirectToPromoPage(promoUrl, true); countClicks('Bukmacher w TD - analityka LOGO');" />
                </div>
                <div class="text-center">
                  <p class="text-[#ABC1E2] text-xs font-semibold">BUKMACHER</p>
                  <div v-if="!toEdit" :id="'bookmaker' + data.comment_id"
                       class="searched-in text-sm whitespace-nowrap overflow-hidden overflow-ellipsis font-medium mt-[3px] xl:mt-0">
                    <a class="no-default-style zt-hover"
                       :href="getSiteLink(bookmaker)" target="_blank" v-html="bookmaker"></a>
                  </div>
                  <select v-else :id="'bookmaker' + data.comment_id" :contenteditable="toEdit" :content="bookmaker"
                          class="text-white w-full rounded-md bg-zt-normal border-white/50 border h-8 text-[14px] mt-1
                            focus:outline-none"
                          v-model="bookmaker">
                    <option selected>Fortuna</option>
                    <option>LVBET</option>
                    <option>eWinner</option>
                    <option>Betfan</option>
                    <option>Betclic</option>
                    <option>Totolotek</option>
                    <option>forBET</option>
                    <option>PZBuk</option>
                    <option>BestBet</option>
                    <option>Betcris</option>
                    <option>STS</option>
                    <option>Goplusbet</option>
                    <option>Superbet</option>
                    <option>TOTALbet</option>
                    <option>Fuksiarz</option>
                    <option>ETOTO</option>
                    <option>BetX</option>
                    <option>Betters</option>
                    <option>Noblebet</option>
                    <option>ComeOn</option>
                    <option>AdmiralBet</option>
                    <option>WettArena</option>
                    <option>Lebull</option>
                  </select>
                </div>
              </div>
            </div>
            <div v-if="toEdit" class="pb-4 pt-2 flex flex-col items-center bg-zt-main my-2 rounded-[8px] px-4">
              <p class="text-[#ABC1E2] text-xs text-center w-full font-semibold">ZMIEŃ DATĘ</p>
              <input class="bg-white/20 px-2 rounded-zt mt-1" type="date" id="start" name="trip-start" v-model="editDate" />
            </div>

            <div v-if="settingsStore.settlement"
                 class="pb-4 pt-2 flex flex-col items-center bg-zt-main my-2 rounded-lg px-4">
              <p class="text-[#ABC1E2] text-[12px] text-center w-full font-semibold">ROZLICZANIE</p>
              <div class="flex justify-between gap-y-2 items-center flex-wrap w-full px-4 mt-2">
                <button class="rate-won rounded-zt px-4 zt-hover h-[50px] w-[110px]"
                        @click="settleBet(1)">
                  WSZEDŁ
                </button>
                <button class="rate-lost rounded-zt px-4 zt-hover h-[50px] w-[110px]"
                        @click="settleBet(-1)">
                  NIE WSZEDŁ
                </button>
                <button class="rate-return rounded-zt px-4 zt-hover h-[50px] w-[110px]"
                        @click="settleBet(0)">
                  ZWROT
                </button>
                <button class="invalid-bet rounded-zt px-4 zt-hover h-[50px] w-[110px]"
                        @click="settleBet(-2)">
                  Czarny kurs
                </button>
                <button class="rate-unchecked rounded-zt px-4 zt-hover h-[50px] w-[110px]"
                        @click="settleBet(-3)">
                  ANULUJ
                </button>
              </div>
              <div class="mt-4 flex flex-col gap-y-2">
                <span v-if="data.link !== ''"
                      class="mr-4 overflow-x-scroll whitespace-nowrap inline-block max-w-[300px] align-bottom">
                  Link: <span v-html="getLink()"></span>
                </span>
                <div>
                  <span>Minusowe punkty: </span>
                  <input class="bg-zt-normal text-text rounded-zt w-12 h-8 text-center" type="number"
                         v-model="penaltyPoints" />
                </div>
              </div>
            </div>

            <div class="p-2 min-h-[60px] flex flex-col justify-center items-center bg-zt-main rounded-lg relative
                   gap-1 my-2.5 xl:gap-0 xl:my-1.5">
              <p class="text-[#ABC1E2] text-xs text-center w-full font-semibold">WYDARZENIE</p>
              <div :id="'match-name' + data.comment_id" ref="matchName" :contenteditable="toEdit"
                   class="text-center max-w-full text-sm font-semibold"
                   @keydown="checkCharacterLimit">
                <div class="text-center relative">
                  <div class="searched-in" v-html="matchName"></div>
                </div>
              </div>
            </div>
            <div class="pb-4 pt-1.5 px-4 min-h-[60px] flex flex-col items-center bg-zt-main mt-2.5 mb-7 rounded-lg relative xl:mt-1.5">
              <p class="text-[#ABC1E2] text-xs text-center w-full font-semibold">TYP{{ isBetbuilder ? ' (BETBUILDER)' : '' }}</p>
              <div v-if="toEdit" class="flex text-xs items-center gap-x-[6px]">
                Betbuilder
                <div
                    @click="editIsBetBuilder = !editIsBetBuilder"
                    class="flex items-center gap-2.5 font-light w-5 h-5 cursor-pointer zt-hover text-[#EEE]">
                  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.5" y="0.5" width="24" height="24" rx="4.5" :fill="editIsBetBuilder ? '#FF4A5D' : '#3A4B6459'" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.38985 15.9466L5.30791 12.2349L3.94727 13.4721L9.38985 18.4211L21.0525 7.81621L19.6919 6.57898L9.38985 15.9466Z"
                          :fill="editIsBetBuilder ? 'white' : 'transparent'" />
                    <rect x="0.5" y="0.5" width="24" height="24" rx="4.5" :stroke="editIsBetBuilder ? '#9B2733' : '#3A4B64'" />
                  </svg>
                </div>
              </div>
              <div v-if="toEdit" class="text-xs text-zt-red">
                <p v-for="error in errors">
                  {{error.content}}
                </p>
              </div>
              <div :id="'type' + data.comment_id" ref="type" :contenteditable="toEdit"
                   class="text-center max-w-full text-sm font-semibold" @keydown="checkCharacterLimit">
                <div class="searched-in text-center relative break-words" v-html="type"></div>
              </div>
              <div class="absolute bottom-0 translate-y-1/2 left-1/2 -translate-x-1/2 rounded-zt h-[26px]
                     flex justify-center items-center w-[90px] overflow-hidden border border-transparent cursor-default select-none"
                   :class="settled
                     ? [getSettleBgColor(), { 'after:absolute after:bg-white after:w-[10%] after:h-full after:top-0 after:right-[110%] after:animate-[bet-result-shine_24s_ease-in-out_infinite] after:blur after:skew-x-12 after:transition-transform': result === 1 }]
                     : 'rate-unchecked'"
                   @click="hideTooltip"
                   data-bs-toggle="tooltip" data-bs-placement="bottom"
                   :title="settled ? (result === 1 ? 'Wygrana' : result === -1 ? 'Przegrana' : result === -2 ? 'Odrzucony (czarny kurs)' : 'Zwrot') : 'Nierozliczony'">
                <div :id="'rate' + data.comment_id" :contenteditable="toEdit"
                     class="text-center text-base whitespace-nowrap overflow-hidden overflow-ellipsis font-semibold relative z-10">
                  {{ rate }}
                </div>
                <div v-if="5 <= rate && rate < 10 && settled && result === 1">
                  <svg class="absolute right-1 top-0 h-8 w-4" viewBox="0 0 17 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.3235 17.5098V19.2193H11.658V20.2944H13.3235V22.0039H14.4867V20.2944H16.1522V19.2193H14.4867V17.5098H13.3235Z" fill="#038733" />
                    <path d="M2.84954 11.3088V13.5882H0.628906V15.0216H2.84954V17.301H4.40047V15.0216H6.6211V13.5882H4.40047V11.3088H2.84954Z" fill="#038733" />
                    <path d="M3.28517 0.660156V1.65739H2.31364V2.28451H3.28517V3.28174H3.9637V2.28451H4.93523V1.65739H3.9637V0.660156H3.28517Z" fill="#038733" />
                    <path d="M11.5164 2.61937V5.32614H8.87938V7.02833H11.5164V9.7351H13.3581V7.02833H15.9951V5.32614H13.3581V2.61937H11.5164Z" fill="#038733" />
                  </svg>
                  <svg class="absolute left-1 top-0 h-12 w-6" viewBox="0 0 17 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.3235 17.5098V19.2193H11.658V20.2944H13.3235V22.0039H14.4867V20.2944H16.1522V19.2193H14.4867V17.5098H13.3235Z" fill="#038733" />
                    <path d="M2.84954 11.3088V13.5882H0.628906V15.0216H2.84954V17.301H4.40047V15.0216H6.6211V13.5882H4.40047V11.3088H2.84954Z" fill="#038733" />
                    <path d="M3.28517 0.660156V1.65739H2.31364V2.28451H3.28517V3.28174H3.9637V2.28451H4.93523V1.65739H3.9637V0.660156H3.28517Z" fill="#038733" />
                    <path d="M11.5164 2.61937V5.32614H8.87938V7.02833H11.5164V9.7351H13.3581V7.02833H15.9951V5.32614H13.3581V2.61937H11.5164Z" fill="#038733" />
                  </svg>
                </div>
                <div v-if="10 <= rate && settled && result === 1">
                  <svg class="absolute top-1/2 left-0 animate-[awesome-bet-rate_3.5s_ease-in_infinite]"
                       style="animation-delay: -0.5s" viewBox="0 0 11 11" width="8" height="8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="m 5.7099829,0.03044904 1.32543,3.98788996 h 4.2891701 l -3.4700001,2.4647 1.3254,3.9879 -3.47,-2.4646 -3.47004,2.4646 1.32544,-3.9879 -3.47003001,-2.4647 H 4.3845429 Z" fill="#038733" />
                  </svg>
                  <svg class="absolute top-1/2 left-2 animate-[awesome-bet-rate_1.5s_ease-in_infinite]"
                       style="animation-delay: -0.2s" viewBox="0 0 11 11" width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="m 5.7099829,0.03044904 1.32543,3.98788996 h 4.2891701 l -3.4700001,2.4647 1.3254,3.9879 -3.47,-2.4646 -3.47004,2.4646 1.32544,-3.9879 -3.47003001,-2.4647 H 4.3845429 Z" fill="#038733" />
                  </svg>
                  <svg class="absolute top-1/2 left-6 animate-[awesome-bet-rate_2.8s_ease-in_infinite]"
                       style="animation-delay: -0.5s" viewBox="0 0 11 11" width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="m 5.7099829,0.03044904 1.32543,3.98788996 h 4.2891701 l -3.4700001,2.4647 1.3254,3.9879 -3.47,-2.4646 -3.47004,2.4646 1.32544,-3.9879 -3.47003001,-2.4647 H 4.3845429 Z" fill="#038733" />
                  </svg>
                  <svg class="absolute top-1/2 right-0 animate-[awesome-bet-rate_4s_ease-in_infinite]"
                       style="animation-delay: -2.5s" viewBox="0 0 11 11" width="8" height="8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="m 5.7099829,0.03044904 1.32543,3.98788996 h 4.2891701 l -3.4700001,2.4647 1.3254,3.9879 -3.47,-2.4646 -3.47004,2.4646 1.32544,-3.9879 -3.47003001,-2.4647 H 4.3845429 Z" fill="#038733" />
                  </svg>
                  <svg class="absolute top-1/2 right-2 animate-[awesome-bet-rate_2.2s_ease-in_infinite]"
                       style="animation-delay: -0.1s" viewBox="0 0 11 11" width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="m 5.7099829,0.03044904 1.32543,3.98788996 h 4.2891701 l -3.4700001,2.4647 1.3254,3.9879 -3.47,-2.4646 -3.47004,2.4646 1.32544,-3.9879 -3.47003001,-2.4647 H 4.3845429 Z" fill="#038733" />
                  </svg>
                  <svg class="absolute top-1/2 right-6 animate-[awesome-bet-rate_1.7s_ease-in_infinite]"
                       style="animation-delay: -0.7s" viewBox="0 0 11 11" width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="m 5.7099829,0.03044904 1.32543,3.98788996 h 4.2891701 l -3.4700001,2.4647 1.3254,3.9879 -3.47,-2.4646 -3.47004,2.4646 1.32544,-3.9879 -3.47003001,-2.4647 H 4.3845429 Z" fill="#038733" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <!-- Bet content -->
          <article v-if="!isBlockedBetShown" ref="content"
                   class="text-sm leading-[21px] bet-content mb-2 pl-3 pr-[18px] break-words font-light xl:px-4 xl:mb-3">
            <span :id="'analysis' + data.comment_id" :contenteditable="toEdit" class="searched-in"
                  v-html="contentTrimmed"></span>
            <span v-if="hideFullContent || hideFullLines">
              ... <span @click="showFullContent" class="zt-hover cursor-pointer text-sm text-zt-more underline">Rozwiń</span>
            </span>
            <span v-if="!isBlockedBetShown"
                  class="inline-flex items-center w-fit text-zt-more text-sm font-light cursor-default pl-1.5 select-none">
              <span v-if="commentType === 'bet'"
                    data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-offset="0,10" data-bs-delay="500" :title="absDate"
                    @click="hideTooltip">
                {{ parsedDate }}
              </span>
            </span>
            <div v-if="isReported" class="mt-2.5">
              <svg class="inline-block w-4 h-4 mr-[5px] xl:w-5 xl:h-5" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.5013 21.0837C12.76 21.0853 14.0067 20.8382 15.1696 20.3564C16.3325 19.8747 17.3888 19.1679 18.2777 18.2767C19.1689 17.3878 19.8757 16.3316 20.3574 15.1686C20.8391 14.0057 21.0863 12.7591 21.0846 11.5003C21.0862 10.2416 20.8391 8.99495 20.3574 7.83204C19.8757 6.66912 19.1689 5.61286 18.2777 4.72396C17.3888 3.83272 16.3325 3.12594 15.1696 2.64422C14.0067 2.16251 12.76 1.91537 11.5013 1.917C10.2426 1.9154 8.99593 2.16255 7.83301 2.64426C6.6701 3.12597 5.61384 3.83274 4.72493 4.72396C3.83372 5.61286 3.12695 6.66912 2.64524 7.83204C2.16353 8.99495 1.91637 10.2416 1.91798 11.5003C1.91635 12.7591 2.16349 14.0057 2.6452 15.1686C3.12691 16.3316 3.8337 17.3878 4.72493 18.2767C5.61384 19.1679 6.6701 19.8747 7.83301 20.3564C8.99593 20.8381 10.2426 21.0853 11.5013 21.0837Z" stroke="#93A3BA" stroke-width="2" stroke-linejoin="round" />
                <circle cx="11.5" cy="16.6" r="1.1" fill="#93A3BA" />
                <path d="M11.5 5.75V13.4167" stroke="#93A3BA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <span class="text-xs text-zt-more xl:text-sm">Typ w trakcie weryfikacji na prośbę użytkowników</span>
            </div>
          </article>
          <div v-if="toEdit" class="flex justify-end text-xs px-2 py-4 xl:px-6 xl:text-sm">
            <button class="bg-zt-red px-2 py-1 rounded mx-2 zt-hover" @click="toEdit = false">Anuluj</button>
            <button class="bg-green-700 px-2 py-1 rounded zt-hover" @click="saveEdit">Zatwierdź</button>
          </div>

          <hr v-if="!isModal && showComments" class="border-b border-zt-light/35 mx-auto w-full !border-t-0 mt-4 xl:mt-1"/>

          <div v-if="!isBlockedBetShown && !isModal && showComments"
               class="h-[42px] flex justify-between items-center pl-1.5 pr-3 xl:pl-2.5 xl:pr-4">
            <div class="group flex highlight-none grow">
              <div class="flex items-center gap-0.5 mr-1 text-sm duration-500 transition-colors cursor-pointer zt-hover"
                   :class="isLikedByMe ? 'text-[#419AD4]' : 'text-zt-more'"
                   @click="toggleLike">
                <svg class="w-7 h-7 overflow-hidden rounded-full transition-colors duration-[1s] shrink-0"
                     :class="[
                       { 'animate-[like-animation_1s]': animate },
                       isLikedByMe ? 'stroke-transparent fill-[#419AD4]' : 'stroke-zt-more fill-transparent'
                     ]"
                     viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.02052 3.29201C7.97899 3.31156 7.953 3.35321 7.95412 3.39843C7.97027 4.05479 7.97835 4.43525 7.97835 4.53979V4.83551L7.92797 4.93901C7.8714 5.05524 7.84218 5.10345 7.42778 5.76467C7.26549 6.02362 7.051 6.37847 6.95113 6.55326C6.8321 6.76157 6.7698 6.99652 6.77024 7.23539L6.77615 10.4265C6.77687 10.8176 7.09988 11.1342 7.49809 11.1342H11.0513L11.1808 11.0718C11.4717 10.9316 11.6853 10.6054 11.6868 10.2988C11.6874 10.1806 11.6836 10.1653 11.6225 10.0417C11.5868 9.96934 11.5594 9.90908 11.5617 9.90775C11.564 9.90642 11.631 9.87712 11.7107 9.84266C12.053 9.69455 12.2544 9.45916 12.269 9.19021C12.2767 9.04821 12.2428 8.95009 12.1285 8.78295C12.0824 8.71557 12.0447 8.65649 12.0447 8.65164C12.0447 8.6468 12.0558 8.64284 12.0695 8.64284C12.0831 8.64284 12.1498 8.61458 12.2177 8.58004C12.5277 8.4223 12.7052 8.12287 12.6549 7.84249C12.6214 7.65568 12.5212 7.50716 12.2986 7.31427L12.2256 7.25107L12.3095 7.16301C12.4176 7.04942 12.4832 6.95595 12.5262 6.85412C12.5546 6.78718 12.5609 6.74432 12.5612 6.6166C12.5617 6.37306 12.5044 6.20983 12.3687 6.06876C12.2778 5.97426 12.1765 5.91277 12.0332 5.86522L11.9155 5.82615C10.2991 5.81738 9.49093 5.81105 9.49096 5.80717C9.49102 5.80134 9.50466 5.6868 9.52127 5.55262C9.55932 5.24537 9.56347 4.6846 9.52919 4.48065C9.43159 3.89988 9.1171 3.44498 8.70331 3.28599C8.5997 3.24619 8.56565 3.2406 8.40398 3.23694C8.30366 3.23467 8.19168 3.2389 8.15517 3.24635C8.11864 3.25379 8.05805 3.27434 8.02052 3.29201ZM4.65918 6.73157H6.03585C6.1572 6.73157 6.25557 6.82819 6.25557 6.94737V11.2209C6.25557 11.3401 6.1572 11.4367 6.03585 11.4367H4.65918C4.53783 11.4367 4.43945 11.3401 4.43945 11.2209V6.94737C4.43945 6.82819 4.53783 6.73157 4.65918 6.73157Z" stroke-width="0.5"/>
                </svg>
                <span class="text-xs xl:text-sm">Lubię to!</span>
                <span class="text-xs mt-[1px] xl:ml-[3px] xl:mr-1"
                      :class="{ 'animate-[flipDown_.4s_ease-in-out]': wsLikeAdded }"
                      @animationend="wsLikeAdded = false" >({{ likeCount }})</span>
              </div>
            </div>
            <div class="flex flex-nowrap justify-center items-center cursor-pointer highlight-none zt-hover"
                 @click="toggleAnswer">
              <button data-bs-toggle="collapse" ref="commentsButton" :data-bs-target="'#Comment-input-' + data.comment_id"
                      class="text-zt-more text-xs xl:text-sm">Komentarze ({{ commentWithAnswersCount }})</button>
            </div>
          </div>
          <div v-else-if="isModal" class="flex justify-center py-4">
            <button class="mx-auto zt-button uppercase" @click.stop="goToBet">
              przejdź do typu
            </button>
          </div>
          <div v-else-if="showComments" class="flex justify-center py-3.5 px-4 xl:px-3">
            <span class="underline text-[14px] text-zt-more zt-hover cursor-pointer" @click="showBlockedBet">
              Rozwiń typ
            </span>
          </div>
        </div>
        <div v-if="showComments" ref="textareaWrapper" :id="'Comment-input-' + data.comment_id" class="collapse">
          <div class="w-full h-0.5 bg-zt-light"></div>
          <div v-if="isLoggedIn() && !isUserBlocking"
               :class="{ '!opacity-100' : !isAnswerOpen }"
               class="flex relative py-2 justify-center opacity-0 transition items-center gap-x-2 px-1.5 xl:px-2.5">
            <img class="rounded-full w-[30px] h-[30px] min-w-[30px]" height="30" width="30" :src="WP.user.avatar" alt="" @error="handleUserAvatarError($event)"/>
            <textarea class="font-light py-2 pl-3 !text-text textarea-comments self-stretch overflow-hidden resize-none
                             focus:outline-none !pr-10 block"
                      placeholder="Napisz komentarz..." ref="textarea" rows="1" @keyup="resize()"
                      v-model="answerContent"></textarea>
            <div class="absolute top-0 h-full flex items-center right-[18px] xl:right-2">
              <button class="zt-hover xl:h-[calc(100%-20px)] xl:px-4" aria-label="Dodaj komentarz" @click="addComment">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.7267 7.55476L2.72665 2.05476C2.64044 2.01164 2.5436 1.99437 2.44779 2.00501C2.35198 2.01566 2.2613 2.05377 2.18665 2.11476C2.11536 2.17451 2.06215 2.25295 2.03301 2.34128C2.00386 2.42961 1.99993 2.52432 2.02165 2.61476L3.50165 7.99976L2.00165 13.3698C1.98126 13.4453 1.97888 13.5245 1.9947 13.6012C2.01052 13.6778 2.0441 13.7496 2.09273 13.8109C2.14136 13.8722 2.2037 13.9212 2.27472 13.954C2.34574 13.9868 2.42347 14.0025 2.50165 13.9998C2.57992 13.9993 2.65699 13.9805 2.72665 13.9448L13.7267 8.44476C13.8086 8.4028 13.8773 8.33905 13.9253 8.26054C13.9733 8.18202 13.9987 8.09178 13.9987 7.99976C13.9987 7.90774 13.9733 7.8175 13.9253 7.73898C13.8773 7.66047 13.8086 7.59672 13.7267 7.55476ZM3.27665 12.5548L4.38165 8.49976H9.00165V7.49976H4.38165L3.27665 3.44476L12.3817 7.99976L3.27665 12.5548Z" fill="#93A3BA"/>
                </svg>
              </button>
            </div>
          </div>
          <div v-else-if="isUserBlocking" class="flex justify-center items-center p-2 mt-0.5">
            <span class="text-zt-red text-[12px] zt-hover cursor-pointer truncate" @click="openLoginModal">
              Zostałeś zablokowany przez tego Typera, nie mozesz skomentować jego typu
            </span>
          </div>
          <div v-else class="flex justify-center items-center p-2 text-sm">
            <div class="flex justify-center items-center gap-1 zt-hover cursor-pointer" @click="openLoginModal">
              <span class="text-zt-red font-medium">Zaloguj się,</span>
              <span>aby dodać komentarz</span>
            </div>
          </div>
        </div>
      </div>

      <TransitionGroup name="fade">
        <comment
          v-for="comment in commentsToShow"
          :key="comment.comment_id"
          :data="comment"
          :isBlocked="betAuthorBlocked(comment.author_id)"
          :isBlocking="betAuthorBlocking(comment.author_id)"
          @follow-post="val => followPost(val)"
          :isBetComment="true"
          :isBetExplicitlyMuted="isBetExplicitlyMuted"
          :isBetFollowed="isBetFollowed"
          :blockedUserIds="blockedUserIds"
          @blockUser="(commentAuthorId) => $emit('blockUser', commentAuthorId)"
          @unblockUser="(commentAuthorId) => $emit('unblockUser', commentAuthorId)"/>
      </TransitionGroup>

      <div v-if="!showAllComments && comments.length > 1" class="flex justify-center items-center">
        <button class="zt-more px-6 py-2 text-sm text-zt-more underline rounded-md mt-2"
                @click="showAllComments = true">
          <span class="zt-hover">Pokaż {{ comments.length - 1 }} {{ inflectNumber(comments.length - 1, ['komentarz', 'komentarze', 'komentarzy']) }}</span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import Comment from './Comment.vue';
import comment_mixin from '../mixins/comment_mixin';
import { defineAsyncComponent } from 'vue';
import utils_mixin from '../mixins/utils_mixin';
import { Notice } from '../../assets/js/Notice';
import { useSettingsStore } from '../stores/SettingsStore';
import { useUserStore } from '../stores/UserStore';
import { useCouponStore } from '../stores/CouponStore';
import BannerKoszulka from './blocks/BannerKoszulka.vue';
import OtherPosts from './daily_bets_items/OtherPosts.vue';
import { DateTime } from 'luxon';
import emoji_mixin from '../mixins/emoji_mixin';
import Tutorial from "./daily_bets_tabs/Tutorial.vue";
import CouponTutorialModal from "./modals/CouponTutorialModal.vue";

export default {
  name: 'BetItem',
  emits: ['blockUser', 'unblockUser', 'edit', 'warnUser', 'removeWarnUser', 'copyBet', 'settleBet', 'changeBetDay', 'editBetIncrement'],
  props: {
    data: Object,
    isBlocked: Boolean,
    isBlocking: Boolean,
    isWarned: Boolean,
    blockedUserIds: Array,
    blockingUserIds: Array,
    warnedUserIds: Array,
    isModal: Boolean,
    betEdited: Number,
    showComments: {
      type: Boolean,
      default: true,
    },
    showCouponAdd: {
      type: Boolean,
      default: true,
    }
  },
  inject: ['WP'],
  mixins: [comment_mixin, utils_mixin, emoji_mixin],
  components: {
	  CouponTutorialModal,
	  Tutorial,
    OtherPosts,
    BannerKoszulka,
    Comment,
    BetOptionsModal: defineAsyncComponent(() => import('./modals/BetOptionsModal.vue')),
    ReportModal: defineAsyncComponent(() => import('./modals/ReportModal.vue'))
  },
  setup() {
    const settingsStore = useSettingsStore();
    const userStore = useUserStore();
    const couponStore = useCouponStore();
    return { settingsStore, userStore, couponStore };
  },
  data() {
    this.siteLinks = {
      fortuna: '/kod-promocyjny-fortuna/',
      lvbet: '/kod-promocyjny-lvbet/',
      ewinner: '/kody-promocyjne-ewinner/',
      betfan: '/kod-promocyjny-betfan/',
      betclic: '/kod-promocyjny-betclic/',
      totolotek: '/kod-promocyjny-totolotek/',
      forbet: '/kod-promocyjny-forbet/',
      pzbuk: '/kod-bonusowy-pzbuk/',
      sts: '/sts-kod-promocyjny/',
      superbet: '/kod-promocyjny-superbet/',
      totalbet: '/kod-promocyjny-totalbet/',
      fuksiarz: '/fuksiarz-kod-promocyjny/',
      etoto: '/kod-bonusowy-etoto/',
      betx: '/kod-promocyjny-betx/',
      bestbet: '/bestbet-bonus/',
      betcris: '/kod-promocyjny-betcris/',
      traf: '/kod-promocyjny-traf/',
      okbet: '/kod-promocyjny-okbet/',
      noblebet: '/kod-promocyjny-noblebet/',
      goplusbet: '/gobet-kod-promocyjny/',
      betters: '/betters-kod-promocyjny/',
      bwin: '/bwin-kod-promocyjny/',
      comeon: '/comeon-kod-bonusowy/',
      admiralbet: '/admiralbet-kod-promocyjny/',
      wettarena: '/wett-arena-kod-promocyjny/',
      lebull: '/lebull-kod-promocyjny/',
    };
    this.disciplines = [
      { title: 'Baseball', search: true, index: 9 },
      { title: 'Dart', search: true, index: 10 },
      { title: 'E-sport', search: true, index: 11 },
      { title: 'Hokej', search: true, index: 2 },
      { title: 'Inna', search: true, index: null },
      { title: 'Koszykówka', search: true, index: 3 },
      { title: 'Piłka nożna', search: true, index: 0 },
      { title: 'Piłka ręczna', search: true, index: 19 },
      { title: 'Siatkówka', search: true, index: 4 },
      { title: 'Sporty walki', search: true, index: 5 },
      { title: 'Sporty zimowe', search: true, index: 6 },
      { title: 'Tenis', search: true, index: 1 },
      { title: 'Żużel', search: true, index: -1 }
    ];
    return {
      comments: [],
      answerContent: '',
      isAnswerOpen: this.isLoggedIn(),
      isBetOptionsModalOpen: false,
      isReportModalOpen: false,
      isReported: !!Number(this.data.is_reported_to_verify),
      showAllComments: false,
      followChanged: false,
      animate: false,
      parsedDate: null,
      lastCommentTimestamp: 0,
      settled: Number(this.data.settled),
      result: Number(this.data.result),
      toEdit: false,
      isMatchNamePagined: true,
      isTypePagined: true,
      absDate: null,
      isShowAllPagedDateDesktop: false,
      showNewBetShadow: false,
      hideFullContent: false,
      hideFullLines: false,
      penaltyPoints: 0,
      isBlockedBetShown: false,
      wsLikeAdded: false,
      editDate: '',
      isApproved: true,
      promoUrl: '',
	    currentFollowOperation: null,
      isUserWithAdminPanel: this.WP.user.role === 'Admin' || this.WP.user.role === 'Moderator' || this.WP.user.role === 'Redaktor',
	    isCouponTutOpen: false,
      likeCount: this.data.like_count,
      editIsBetBuilder: false,
      errors: [],
    };
  },
  computed: {
    supportLink() {
      return this.data.support_link;
    },
    awardType() {
      return this.data.award_type;
    },
    contentTrimmed() {
      if (this.hideFullLines) {
        const splitBy = this.data.content?.includes('<br>') ? '<br>' : '<br />';

        let content = this.data.content?.split(splitBy).slice(0, 30).join(splitBy);
        return content[content.length - 1] === '>' ? content.slice(0, -1) : content;
      }

      return this.hideFullContent ? this.data.content.slice(0, 2000) : this.data.content;
    },
    bookmaker() {
      return this.betEdited && this.data.bookmaker;
    },
    isBetbuilder() {
      return this.betEdited && this.data.is_betbuilder === '1';
    },
    bookmakerLogoName() {
      return this.data.bookmaker.replace(/<span>|<\x2fspan>/gi, '');
    },
	  betFollowers() {
			return this.data.bet_followers;
	  },
	  isBetExplicitlyMuted() {
		  const followItem = this.betFollowers.filter(item => +item.user_id === this.WP.user.id);
		  if (followItem.length === 1 && followItem[0].muted === '1') {
			  return true;
		  }
			return false
	  },
	  isBetFollowed() {
			if (this.currentFollowOperation === 'following') {
				return true;
			}
			if (this.currentFollowOperation === 'muted') {
				return false;
			}
			const followItem = this.betFollowers.filter(item => +item.user_id === this.WP.user.id);
			if (followItem.length === 1 && followItem[0].muted === '1') {
				return false;
			}
			if (followItem.length === 1 && followItem[0].follows === '1') {
				return true;
			}
      if (this.WP.user.id === +this.authorId) {
        return true;
      }
			const hasUserCommentedBet = this.comments.filter(comment => +comment.author_id === this.WP.user.id).length === 1;
			let hasNestedUserComment = false;
			for (let comment of this.comments) {
				comment.answers?.forEach(ans => {
					if (+ans.author_id === this.WP.user.id) {
						hasNestedUserComment = true;
					}
				})
			}
			if (hasUserCommentedBet || hasNestedUserComment) {
				return true;
			}
			return false;
	  },
    disciplineLogoName() {
      return this.data.discipline.replace(/<span>|<\x2fspan>/gi, '');
    },
    authorStats() {
      return this.data.author_stats;
    },
    discipline() {
      return this.betEdited && this.data.discipline;
    },
    hour() {
      return this.betEdited && this.data.hour;
    },
    matchDate() {
      return this.betEdited && this.data.match_date;
    },
    matchName() {
      return this.betEdited && this.data.match_name;
    },
    rate() {
      return this.betEdited && this.data.rate;
    },
    type() {
      return this.betEdited && this.data.type;
    },
    commentWithAnswersCount() {
      let count = 0;
      if (this.comments.length > 0) {
        this.comments.forEach(child => {
          if ('answers' in child && child.answers.length > 0) {
            count += child.answers.length;
          }
          count++;
        });
      }
      return count;
    },
    id() {
      return Number(this.data.comment_id);
    },
    postId() {
      return Number(this.data.post_id);
    },
    authorId() {
      return Number(this.data.author_id);
    },
    authorAvatar() {
      return this.data.author_avatar;
    },
    authorRole() {
      return this.data.author_role;
    },
    authorName() {
      return this.data.author_name.replace(/ /, '\n');
    },
    date() {
      return this.data.date;
    },
    content() {
      return this.betEdited && this.data.content;
    },
    isLikedByMe() {
      if (this.isModal || this.commentType !== 'bet' || this.likeCount === 0) {
        return false;
      }
      return this.userStore.isCommentLiked(this.id);
    },
    isUserBlocked() {
      return this.isBlocked;
    },
    isUserBlocking() {
      return this.isBlocking;
    },
    isUserWarned() {
      return this.isWarned;
    },
    warnCount() {
      if (this.isWarned && this.warnedUserIds.length > 0) {
        return this.warnedUserIds.find(el => {
          return el.user_id === this.authorId;
        })?.warn_count;
      } else return null;
    },
    commentType() {
      return this.data.comment_type;
    },
    isMyComment() {
      return Number(this.WP.user.id) === this.authorId;
    },
    commentsToShow() {
      let commentsSorted = this.comments.slice().sort((a, b) => {
        if (a.pinned_to_all !== b.pinned_to_all) {
          return b.pinned_to_all - a.pinned_to_all;
        }

        return new Date(b.date) - new Date(a.date);
      });

      if (this.showAllComments) {
        return commentsSorted;
      } else {
        return commentsSorted.slice(0, 1);
      }
    },
    isFollowed() {
      return this.userStore.isUserFollowed(this.authorId);
    },
    ticketBookmaker() {
      if (this.data.comment_type === 'ticket') {
        return this.data.buk_name;
      } else {
        return null;
      }
    }
  },
  watch: {
    isFollowed() {
      this.followChanged = true;
      setTimeout(this.refreshTooltips, 500);
    },
    isUserBlocked() {
      this.isBlockedBetShown = !this.isBlockedBetShown;
    }
  },
  mounted() {
    if (this.isLoggedIn() && this.showComments) {
      this.$refs.commentsButton.click();
    }
    this.ifHasJustBeenAdded();
    this.parseDate();
    this.setAbsDate();
    this.showBetRedirectBg();
    this.isApproved = !!Number(this.data.comment_approved);
    this.isBlockedBetShown = this.betAuthorBlocked(this.authorId);
    this.comments = this.data.answers ? this.data.answers : [];
    this.checkAndRedirectToComment();
    if (this.data.bookmaker) {
      this.promoUrl = utils_mixin.methods.getBookiePromoLink(this.data.bookmaker);
    }

    const splitBy = this.data.content?.includes('<br>') ? '<br>' : '<br />';

    if (this.data.content?.split(splitBy).length > 30) {
      this.hideFullLines = true;
    } else if (this.data.content?.length > 2000) {
      this.hideFullContent = true;
    }
    setTimeout(this.refreshTooltips, 500);

    this.$refs.content.addEventListener('copy', this.copyListener);

    socket?.on('like-added', data => {
      if (data.postId === Number(this.WP.id)) {
        this.addLikeBySomeoneElse(data);
      }
    });
    socket?.on('like-removed', data => {
      if (data.postId === Number(this.WP.id)) {
        this.removeLikeBySomeoneElse(data);
      }
    });
    this.editIsBetBuilder = this.data.is_betbuilder === '1';
  },
  unmounted() {
    if (this.$refs.content) {
      this.$refs.content.removeEvent('copy', this.copyListener);
    }
  },
  methods: {
    redirect() {
      if (this.supportLink.includes('https')) {
        window.open(this.supportLink, '_blank');
        return;
      }
      window.open(`//${this.supportLink}`, '_blank');
    },
    getAwardText(award_type) {
      switch (parseInt(award_type)) {
        case 1:
          return 'HOT ANALIZA';
        case 2:
          return 'WYSOKI KURS';
        case 3:
          return 'DOBRA PASSA';
        case 4:
          return 'POPULARNY TYP';
        default:
          return '';
      }
    },
    changeFiltering(discipline) {
      this.countClicks('Dyscyplina w PTD - podkreślona', 'bets');
      const allDisciplines = utils_mixin.data().allDisciplines;
      let disciplineIndex = allDisciplines.findIndex(item => item.title === discipline);

      if (discipline === 'Inna') {
        disciplineIndex = allDisciplines.findIndex(item => item.title === 'Inne');
      }

      if (disciplineIndex === -1) {
        return;
      }

      this.emitter.emit('changeTDFiltering', allDisciplines[disciplineIndex]);
    },
	  followPost(showNotification = true) {
      if (!this.isLoggedIn()) {
        this.openLoginModal();
        return;
      }
			axios
				.post(this.WP.ajaxUrl, {
					endpoint: 'api_follow_post_for_notifications',
					operation: 'follow',
					comment_id: this.id
				})
				.then(response => {
					this.currentFollowOperation = 'following';
					const index = this.data.bet_followers.findIndex(item => +item.user_id === this.WP.user.id);
					if (index !== -1) {
						this.data.bet_followers[index].muted = '0';
						this.data.bet_followers[index].follows = '1';
					} else {
						this.data.bet_followers.push({
							user_id: this.WP.user.id,
							muted: '0',
							follows: '1'
						});
					}
					if (showNotification) {
            this.addInternalNotification(new Notice().setContent(response.data.data.msg + " typ"));
          }
				})
	  },
	  unfollowPost() {
      if (!this.isLoggedIn()) {
        this.openLoginModal();
        return;
      }
		  axios
			  .post(this.WP.ajaxUrl, {
				  endpoint: 'api_follow_post_for_notifications',
				  operation: 'mute',
				  comment_id: this.id
			  })
			  .then(response => {
					this.currentFollowOperation = 'muted';
				  const index = this.data.bet_followers.findIndex(item => +item.user_id === this.WP.user.id);
				  if (index !== -1) {
					  this.data.bet_followers[index].muted = '1';
					  this.data.bet_followers[index].follows = '0';
				  } else {
					  this.data.bet_followers.push({
						  user_id: this.WP.user.id,
						  muted: '1',
						  follows: '0'
					  })
				  }
				  this.addInternalNotification(new Notice().setContent(response.data.data.msg + " typ"));
			  })
	  },
    copyListener() {
      const range = window.getSelection().getRangeAt(0),
        rangeContents = range.cloneContents(),
        pageLink = `Czytaj więcej na ${document.location.href}/#comment-${this.id}`,
        helper = document.createElement('div');

      helper.appendChild(rangeContents);

      event.clipboardData.setData('text/plain', `${helper.innerText}\n${pageLink}`);
      event.clipboardData.setData('text/html', `${helper.innerHTML}<br>${pageLink}`);
      event.preventDefault();
    },
    showFullContent() {
      this.hideFullContent = false;
      this.hideFullLines = false;
    },
    showBlockedBet() {
      let index = this.blockedUserIds.findIndex(id => id === this.authorId);
      if (index !== -1) {
        this.isBlockedBetShown = false;
      }
    },
    ifHasJustBeenAdded() {
      if (this.data.showNewBetShadow) {
        this.observeBetShadow();
      }
    },
    setAbsDate() {
      const betDate = this.DateTime.fromSQL(this.date);
      let year = '';
      if (betDate.year !== this.DateTime.now().year) {
        year = 'y ';
      }
      this.absDate = betDate.day + betDate.toFormat(` MMMM ${year}'o' HH:mm`);
    },
    parseDate() {
      const currentDate = this.DateTime.now();
      const betDate = this.DateTime.fromSQL(this.date);

      const diff = betDate.diff(currentDate, ['days', 'hours', 'minutes', 'seconds', 'milliseconds']);

      if (diff.days === 0 && diff.hours === 0 && diff.minutes === 0 && diff.seconds >= 0) {
        this.parsedDate = `przed chwilą`;
      } else if (diff.days === 0 && diff.hours === 0 && diff.minutes === 0) {
        this.parsedDate = `przed chwilą`;
      } else if (diff.days === 0 && diff.hours === 0) {
        this.parsedDate = `${-diff.minutes} min. temu`;
      } else if (diff.days === 0) {
        this.parsedDate = `${-diff.hours} godz. temu`;
      } else if (diff.days === -1) {
        this.parsedDate = `1 dzień temu`;
      } else {
        this.parsedDate = `${-diff.days} dni temu`;
      }
      setTimeout(() => {
        this.parseDate();
      }, 60000);
    },
    resize() {
      const { textarea, textareaWrapper } = this.$refs;
      textarea.style.height = 'auto';
      textareaWrapper.style.height = 20 + textarea.scrollHeight + 'px';
      textarea.style.height = 2 + textarea.scrollHeight + 'px';
    },
    showBetOptionsModal(elementIdPrefix) {
      if (window.size.desktop && !this.isBlocked) {
        this.smoothScrollToElement(elementIdPrefix);
      }
      this.isBetOptionsModalOpen = true;
      this.blockScrolling();
    },
    hideBetOptionsModal() {
      this.isBetOptionsModalOpen = false;
      this.unblockScrolling();
    },
    blockUser(isCancel = false) {
      if (!this.isLoggedIn()) {
        this.openLoginModal();
        return;
      }
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_block_user',
          blocked_user_id: this.authorId
        })
        .then(response => {
          if (response.data.success) {
            this.isBetOptionsModalOpen = false;
            this.$emit('blockUser', this.authorId);
            if (!isCancel) {
              this.addInternalNotification(new Notice().setContent(response.data.data.message)
                  .setCancelAction(this.unblockUser.bind(this, true)));
            }
          } else {
            this.addInternalNotification(new Notice().setContent(response.data.data));
          }
        });
    },
    unblockUser(isCancel = false) {
      if (!this.isLoggedIn()) {
        this.openLoginModal();
        return;
      }
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_unblock_user',
          blocked_user_id: this.authorId
        })
        .then(response => {
          if (response.data.success) {
            this.$emit('unblockUser', this.authorId);
            if (!isCancel) {
              this.addInternalNotification(new Notice().setContent(response.data.data.message)
                  .setCancelAction(this.blockUser.bind(this, true)));
            }
          } else {
            this.addInternalNotification(new Notice().setContent(response.data.data));
          }
        });
    },
    follow(isCancel = false) {
      if (!this.isLoggedIn()) {
        this.openLoginModal();
        return;
      }
      if (this.blockedUserIds.includes(this.authorId)) {
        return;
      }
      this.userStore.followUser(this.authorId, isCancel);
    },
    unfollow(isCancel = false) {
      if (!this.isLoggedIn()) {
        this.openLoginModal();
        return;
      }
      this.userStore.unfollowUser(this.authorId, isCancel);
    },
    warnUser() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_warn_user',
          user_id: this.authorId,
          comment_id: this.id,
        })
        .then(response => {
          if (response.data.success) {
            this.$emit('warnUser', this.authorId);
          }
        });
    },
    removeWarnUser() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_remove_warn_user',
          user_id: this.authorId
        })
        .then(response => {
          if (response.data.success) {
            // comment_mixin.methods.unfollowAuthor(this.authorId, this.followedUserIds);
            this.$emit('removeWarnUser', this.authorId);
          }
        });
    },
    edit() {
      this.toEdit = true;
    },
    pushError(type, content) {
      this.errors.push({ type, content });
    },
    validateBetBuilder(type) {
      if ((type.toLowerCase().includes('betbuilder') || type.toLowerCase().includes('builder')) && !this.editIsBetBuilder) {
        this.pushError('type', `Zaznacz na górze "Betbuilder"`);
        return;
      }
      if (this.editIsBetBuilder && !type.includes('+')) {
        this.pushError('type', 'Typ powinien zawierać symbol "+"');
      }
    },
    saveEdit() {
      this.errors = [];
      const type = document.getElementById('type' + this.data.comment_id).textContent;
      this.validateBetBuilder(type);

      if (this.errors.length > 0) {
        return;
      }

      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_update_bet',
          post_id: this.WP.id,
          discipline: document.getElementById('discipline' + this.data.comment_id).value,
          rate: document.getElementById('rate' + this.data.comment_id).textContent,
          hour: document.getElementById('hour' + this.data.comment_id).textContent,
          bookmaker: document.getElementById('bookmaker' + this.data.comment_id).value,
          match_name: document.getElementById('match-name' + this.data.comment_id).textContent,
          type: type,
          analysis: document.getElementById('analysis' + this.data.comment_id).innerHTML,
          id: this.data.comment_id,
          date: this.editDate,
          is_betbuilder: this.editIsBetBuilder
        })
        .then(response => {
          if (response.data.success) {
            this.data.hour = document.getElementById('hour' + this.data.comment_id).textContent;
            this.data.rate = document.getElementById('rate' + this.data.comment_id).textContent;
            this.data.type = document.getElementById('type' + this.data.comment_id).textContent;
            this.data.content = document.getElementById('analysis' + this.data.comment_id).innerHTML;
            this.data.match_name = document.getElementById('match-name' + this.data.comment_id).textContent;
            this.data.bookmaker = document.getElementById('bookmaker' + this.data.comment_id).value;
            this.data.discipline = document.getElementById('discipline' + this.data.comment_id).value;
            this.data.is_betbuilder = this.editIsBetBuilder ? '1' : '0';
            this.toEdit = false;
            this.$emit('editBetIncrement');
            if (this.editDate !== '') {
              let choosenDate = this.DateTime.fromSQL(this.editDate).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
              let postDate = this.DateTime.fromSQL(this.WP.dailyBetsDate);
              let days = this.Interval.fromDateTimes(postDate, choosenDate).length('days');
              if (days !== 0) {
                this.$emit('changeBetDay', this.id);
              }
            }
          }
        });
    },
    settleBet(result) {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_settle_bet',
          bet_id: this.id,
          result: result,
          points: this.penaltyPoints,
          author_id: this.authorId,
          daily_bets_date: this.WP.dailyBetsDate
        })
        .then(response => {
          if (response.data.success) {
            this.settled = Number(response.data.data.bet.settled);
            this.result = Number(response.data.data.bet.result);

            if (this.settled === 1 && this.result === 1) {
              if (Number(this.rate) >= 5) {
                this.awardBet(2);
              } else if (response.data.data.bet.good_streak) {
                this.awardBet(3);
              } 
            }
          }
        });
    },
    awardBet(award_type) {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_award_bet',
          bet_id: this.id,
          author_id: this.authorId,
          award_type: award_type,
          daily_bets_date: this.WP.dailyBetsDate
        })
        .then(response => {
          if (response.data.success) {
            if (award_type === 2) {
              this.addInternalNotification(new Notice().setContent('Wyróżniono typ jako WYSOKI KURS'));
            } else if (award_type === 3) {
              this.addInternalNotification(new Notice().setContent('Wyróżniono typ jako DOBRA PASSA'));
            }
          }
        });
    },
    toggleLike() {
      this.animate = true;
      if (this.isLikedByMe) {
        this.animate = false;
        return this.removeLike();
      } else {
        return this.addLike();
      }
    },
    addLike() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_add_comment_like',
          comment_id: this.id,
          is_bet: true
        })
        .then(response => {
          if (response.data.success) {
            if (response.data.data.message !== 'error') {
              this.userStore.addLikedCommentId(this.id);
              this.likeCount++;
              socket?.emit('like-added', {
                commentId: this.id,
                parentId: this.id,
                postId: this.postId,
                userId: response.data.data.comment_like.user_id,
              });
              if (this.authorId.toString() === this.WP.user.id.toString()) {
                return;
              }
              const dateOfMatch = new Date(this.matchDate);
              const currentDate = new Date();
              if (Number(this.likeCount) >= 20 && dateOfMatch > currentDate) {
                this.awardBet(4);
              }
              if (+this.authorId !== 0) {
                const notificationData = {
                  recipientId: +this.authorId,
                  comment_id: this.id.toString(),
                  post_id: this.postId.toString(),
                  sender_id: response.data.data.comment_like.user_id.toString(),
                  seen: '0',
                  created_at: DateTime.now().toFormat('yyyy-MM-dd HH:mm:ss'),
                  type: 'BetLike',
                  sender_avatar: this.WP.user.avatar,
                  sender_name: this.WP.user.name || false,
                  id: response.data.data.id
                };
                socket?.emit('notify-user', notificationData);
              }
            }
          }
        });
    },
    removeLike() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_delete_comment_like',
          comment_id: this.id
        })
        .then(response => {
          if (response.data.success) {
            if (response.data.data.message !== 'error') {
              this.userStore.removeLikedCommentId(this.id);
              this.likeCount--;
              socket?.emit('like-removed', {
                commentId: this.id,
                parentId: this.id,
                postId: this.postId,
                userId: this.WP.user.id,
              });
            }
          }
        });
    },
    addComment() {
      if (this.lastCommentTimestamp && this.DateTime.now().toSeconds() - this.lastCommentTimestamp < 10) {
        this.addInternalNotification(new Notice().setContent('Odczekaj chwilę, zanim dodasz kolejny komentarz'));
        return;
      }

      let commentContent = this.parseEmoji(this.answerContent);
      commentContent = this.removeUnicodeLeaveEmojis(commentContent);

      if (commentContent.replace(/\s/g, "").length < 1) {
        this.addInternalNotification(new Notice().setContent('Dodaj treść komentarza'));
        return;
      }

      this.lastCommentTimestamp = this.DateTime.now().toSeconds();

      axios
        .post(this.WP.slowAjaxUrl, {
          endpoint: 'api_add_comment',
          post_id: this.postId,
          parent_id: this.id,
          parent_type: {
            parent: 'Bets',
            grandparent: 'TD'
          },
          content: commentContent.trim(),
          comment_type: 'comment',
          year: this.DateTime.fromSQL(this.WP.dailyBetsDate).year,
          month: this.DateTime.fromSQL(this.WP.dailyBetsDate).month,
        })
        .then(response => {
          if (response.data.success) {
            if (!this.isBetFollowed) {
              this.followPost(false);
            }
            this.comments.unshift(response.data.data.comment);
            this.isAnswerOpen = false;
            this.answerContent = '';
            setTimeout(this.resize, 200);
            if (response.data.data.notification) {
              const notificationData = response.data.data.notification;
              const commentData = response.data.data.comment;
              this.showAllComments = true;
              for (let i = 0; i < notificationData.length; i++) {
                const notification = notificationData[i];
                const data =  {
                  recipientId: +notification.recipient_id,
                  comment_id: notification.comment_id.toString(),
                  post_id: this.postId.toString(),
                  sender_id: notification.sender_id.toString(),
                  seen: '0',
                  created_at: DateTime.now().toFormat('yyyy-MM-dd HH:mm:ss'),
                  type: notification.type,
                  content: commentContent.trim(),
                  sender_avatar: commentData.author_avatar,
                  sender_name: commentData.author_name,
                  parent_author: notification.parent_author,
                  parent_type: notification.parent_type,
                  id: notification.id,
                };
                socket?.emit('notify-user', data);
              }
            }
          } else {
              this.addInternalNotification(new Notice().setContent(response.data.data));
            }
          });
    },
    changeUrl() {
      window.history.replaceState(null, '', window.location.href.split('#')[0] + '/#comment-' + this.id);
    },
    checkAndRedirectToComment() {
      const redirectURL = window.location.href;
      const expectedURL = window.location.href.split('#')[0] + '#comment-' + this.id;
      const isRedirecting = redirectURL.includes('#comment-');
      const dashIndex = redirectURL.lastIndexOf('-');

      if (isRedirecting && dashIndex && redirectURL !== expectedURL) { // only for hidden bet comments
        const commentId = redirectURL.substring(dashIndex + 1);
        this.comments.forEach((comment) => {
          if (comment.comment_id === commentId && this.comments.length > 1) {
            this.showAllComments = true;
          } else if (comment.answers.length > 0) {
            comment.answers.forEach((comment2ndLvl) => {
              if (comment2ndLvl.comment_id === commentId) {
                this.showAllComments = true;
              }
            })
          }
        })
      }
    },
    showBetRedirectBg() {
      const currentURL = window.location.href;
      const expectedURL = window.location.href.split('#')[0] + '#comment-' + this.id;
      if (currentURL === expectedURL) {
        this.observeBetShadow();
      }
    },
    observeBetShadow() {
      this.showNewBetShadow = true;
      let threshold = this.$el.getBoundingClientRect().height > window.innerHeight - 100
        ? (window.innerHeight - 100) / this.$el.getBoundingClientRect().height
        : 1.0;
      const newBetObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              setTimeout(() => (this.showNewBetShadow = false), 3000);
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: threshold,
          rootMargin: '0px 0px 0px 0px'
        }
      );
      setTimeout(() => newBetObserver.observe(this.$el), 400);
    },
    toggleAnswer() {
      this.isAnswerOpen = !this.isAnswerOpen;

      if (this.isAnswerOpen) {
        setTimeout(() => {
          const { textarea } = this.$refs;
          if (textarea) {
            textarea.focus();
          }
        }, 200);
      }
    },
    getSettleBgColor() {
      return {
        'rate-won': this.settled && this.result === 1,
        'rate-lost': this.settled && this.result === -1,
        'rate-return': this.settled && this.result === 0,
        'invalid-bet': this.settled && this.result === -2
      };
    },
    addLikeBySomeoneElse(data) {
      if (data.commentId === this.id) {
        this.likeCount++;
        this.wsLikeAdded = true;
      }
    },
    removeLikeBySomeoneElse(data) {
      if (data.commentId === this.id) {
        this.likeCount--;
      }
    },
    betAuthorBlocked(authorId) {
      return this.blockedUserIds.includes(Number(authorId));
    },
    betAuthorBlocking(authorId) {
      return this.blockingUserIds.includes(Number(authorId));
    },
    betAuthorWarned(authorId) {
      return this.warnedUserIds.some(el => {
        return el.user_id === Number(authorId);
      });
    },
    copyUserBet() {
      let bet  = "Dyscyplina: " + this.discipline + "\n" +
                 "Godzina: " + this.hour + "\n" +
                 "Wydarzenie: " + this.matchName + "\n" +
                 "Typ: " + this.type + "\n" +
                 "Kurs: " + this.rate + "\n" +
                 "Bukmacher: " + this.bookmaker + "\n\n" +
                 "Analiza: " + this.content.replaceAll(new RegExp('<br /><br />|<br />', 'g')) + "\n\n" +
                 "Opublikowano na: " + `${window.location.origin}/?p=${this.postId}/#comment-${this.id}`;
      navigator.clipboard.writeText(bet).then(
          () => {
            this.addInternalNotification(new Notice()
              .setContent('Skopiowano typ!'));
          }, () => {
            this.addInternalNotification(new Notice()
              .setContent('Nie udało się skopiować typu!'));
          }
      );
    },
    deleteBet() {
      axios
        .post(this.WP.slowAjaxUrl, {
          endpoint: 'api_delete_comment',
          id: this.id
        })
        .then(response => {
          if (response.data.success) {
            this.addInternalNotification(new Notice().setContent(response.data.data.message + '. Odśwież stronę'));
          } else {
            this.addNotification(new Notice().setContent('Coś poszło nie tak spróbuj ponownie'));
          }
        });
    },
    getBatteryColor() {
      if (this.data.author_stats.bet_count <= 0) {
        return '#3A4B64';
      }
      if (this.data.author_stats.ratio < 0.2) {
        return '#CE2121';
      } else if (this.data.author_stats.ratio < 0.4) {
        return '#C55E00';
      } else if (this.data.author_stats.ratio < 0.65) {
        return '#FAFF00';
      } else {
        return '#1CC200';
      }
    },
    getBatteryType() {
      if (this.data.author_stats.bet_count <= 0) {
        return 6;
      }
      if (this.data.author_stats.ratio < 0.2) {
        return 1;
      } else if (this.data.author_stats.ratio < 0.4) {
        return 2;
      } else if (this.data.author_stats.ratio < 0.65) {
        return 3;
      } else if (this.data.author_stats.ratio < 0.75) {
        return 4;
      } else if (this.data.author_stats.ratio < 0.85) {
        return 5;
      } else {
        return 6;
      }
    },
    getSiteLink(bookmakerName) {
      const regex = /<span>|<\x2fspan>/gi;
      return this.siteLinks[bookmakerName.toLowerCase().replaceAll(regex, '')] ?? '#';
    },
    getLink() {
      let approvedSites = [
        'https://www.flashscore.pl/',
        'https://www.sofascore.com/',
        'https://pl.egamersworld.com/',
        'https://www.hltv.org/',
        'https://www.plusliga.pl/',
        'https://www.twitch.tv/'
      ];
      let linkFromApprovedSite = approvedSites.some(site => this.data.link.startsWith(site));
      if (linkFromApprovedSite) {
        return `<a href="${this.data.link}" aria-label="link do uprawnionej strony" target="_blank" class="text-zt-green zt-hover">${this.data.link}</a>`;
      } else {
        return `<span class="text-gray-500">${this.data.link}</span>`;
      }
    },
    hideTooltip(event) {
      for (const element of event.composedPath()) {
        if (typeof element === 'object' && element !== null && 'getAttribute' in element && element.hasAttributes()) {
          for (const attr of element.attributes) {
            if (attr.name === 'data-tooltip-created') {
              setTimeout(() => {
                let tooltip = Tooltip.getInstance(element);
                tooltip.hide();
              }, 3000);
              return;
            }
          }
        }
      }
    },
    goToBet() {
      window.location.href = '/?p=' + this.postId + '/#comment-' + this.commentId;
    },
    checkCharacterLimit(event) {
      const maxLength = 100;
      const text = event.target.textContent;
      const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'];

      if (text.length > maxLength && !allowedKeys.includes(event.key)) {
        event.preventDefault();
      }
    },
    addReport() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_set_bet_verification_warning',
          bet_id: this.id,
          status: true
        })
        .then(response => {
          if (response.data.success) {
            this.isReported = true;
          } else {
            this.addNotification(new Notice().setContent('Coś poszło nie tak spróbuj ponownie'));
          }
        });
    },
    removeReport() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_set_bet_verification_warning',
          bet_id: this.id,
          status: false
        })
        .then(response => {
          if (response.data.success) {
            this.isReported = false;
          } else {
            this.addNotification(new Notice().setContent('Coś poszło nie tak spróbuj ponownie'));
          }
        });
    },
    showReportModal() {
      this.isReportModalOpen = true;
      setTimeout(() => {
        this.blockScrolling();
      }, 50);
    },
    hideReportModal() {
      this.isReportModalOpen = false;
      this.unblockScrolling();
    },
    addToCoupon() {
      if (this.couponStore.addedBets.length < 20) {
        if (this.couponStore.addedBets.findIndex( el => {
          return el.id === this.id;
        }) < 0 ) {
          this.couponStore.addedBets.push({
            id: this.id,
            discipline: this.discipline,
            match_name: this.matchName,
            type: this.type,
            rate: this.rate,
            hour: this.hour,
            match_date: this.matchDate,
            postId: this.WP.id,
          });
          this.couponStore.saveToLocalStorage();
					if (window.size.mobile) {
						let couponTutAlreadySeen = localStorage.getItem('coupon-tutorial-seen');
						if (!couponTutAlreadySeen) {
							this.isCouponTutOpen = true;
							localStorage.setItem('coupon-tutorial-seen', '1');
						}
					}
          this.addInternalNotification(new Notice()
              .setContent('Dodano typ do kuponu!'));
        } else {
          this.addInternalNotification(new Notice()
              .setContent('Typ został już dodany do kuponu'));
        }
      } else {
        this.addInternalNotification(new Notice()
            .setContent('Maksymalna liczba zdarzeń na kuponie to 20'));
      }
    },
  }
};
</script>

<style>
.add-bet div::-webkit-scrollbar {
  -webkit-appearance: none;
}

.add-bet div::-webkit-scrollbar:horizontal {
  height: 0;
}

.add-bet div {
  scrollbar-width: none;
}

.warn::before {
  content: '';
  display: inline-block;
  width: 15px;
  height: 15px;
  margin-right: 10px;
  -moz-border-radius: 7px;
  -webkit-border-radius: 7px;
  border-radius: 7px;
  background-color: #f5a836;
}

.MP-text-shadow {
  text-shadow: 0px 0px 5px #888888;
}

.rate-unchecked {
  background: linear-gradient(90.93deg, #D7D7D7 0.8%, #8D8D8D 81.82%, #848484 159.39%) padding-box,
              linear-gradient(180deg, #FFFFFF 0%, #AFAFAF 46.35%, #666666 100%) border-box;
  text-shadow: 0px 0px 5px #888888;
  color: #000000;
}

.rate-lost {
  background: linear-gradient(90.93deg, #D60D0D 0.8%, #A00101 81.82%, #8A0000 159.39%) padding-box,
              linear-gradient(180deg, #FF6069 0%, #FF4646 46.35%, #D56565 100%) border-box;
  text-shadow: 0px 0px 5px #910000;
  color: #F9F9F9;
}

.rate-won {
  background: linear-gradient(90.93deg, #59D60D 0.8%, #01A041 81.82%, #138A00 159.39%)padding-box,
              linear-gradient(180deg, #93FF60 0%, #81FF46 46.35%, #65D592 100%) border-box;
  text-shadow: 0px 0px 5px #009138;
  color: #F9F9F9;
}

.rate-return {
  background: linear-gradient(90.93deg, #C6D60D 0.8%, #A09101 81.82%, #8A6C00 159.39%)padding-box,
              linear-gradient(180deg, #FFF960 0%, #FFF846 46.35%, #D2D565 100%) border-box;
  text-shadow: 0px 0px 5px #916800;
  color: #F9F9F9;
}

.invalid-bet {
  background: linear-gradient(90.93deg, #212121 0.8%, #0000005C 81.82%, #313131 159.39%)padding-box,
              linear-gradient(180deg, #060606 0%, #180B0B 46.35%, #151515 100%) border-box;
  text-shadow: 0px 0px 5px #888888;
  color: #FFFFFF;
}

.bet-content ul {
  @apply list-disc list-outside ml-4 text-left;
}

.bet-content ol {
  @apply list-decimal list-outside ml-4 text-left;
}

.bet-content img {
  @apply mx-auto rounded-zt;
}

.fade-enter-active,
.fade-leave-active {
  z-index: 10;
  transition: all 0.3s ease-out;
}

.fade-enter-from,
.fade-leave-to {
  z-index: 10;
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease-out;
  max-height: 55px;
}

.slide-enter-from,
.slide-leave-to {
  max-height: 0;
  opacity: 0;
}

.searched-in .searched-element {
  background-color: #6FAD6E99;
}

.textarea-comments::placeholder {
  color: #93A3BA;
}

</style>
